import React                         from 'react';

import { Ripple                    } from 'src/components/common/ripple';
import { Label,  
         IconWrapper,
         LabelContainer,
         ButtonWithIconVariants, 
         ButtonWithIconContainer,
         button_with_icon_variants } from 'src/components/common/button-with-icon/ui';



type Props = {
  variant: ButtonWithIconVariants;
  label?: string;
  leftSideIcon?: React.ReactNode;
  rightSideIcon?: React.ReactNode;
  labelPosition?: 'center' | 'left' | 'right';
  isDisabled?: boolean;
  onTap: () => void;
}
export const ButtonWithIcon: React.FC<Props> = ({
  variant,
  label,
  leftSideIcon,
  rightSideIcon,
  labelPosition = 'left',
  isDisabled = false,
  onTap,
}) => {
  const lookAndFeel = button_with_icon_variants.get(variant)!;

  return (
    <Ripple isTapAllowed = { !isDisabled } onTap = { onTap }>
      <ButtonWithIconContainer lookAndFeel = { lookAndFeel } disabled = { isDisabled } >
        <IconWrapper lookAndFeel = { lookAndFeel }>
          { leftSideIcon !== undefined && leftSideIcon }
        </IconWrapper>
        {label !== undefined && 
          <LabelContainer labelPosition = { labelPosition }>
            <Label lookAndFeel = { lookAndFeel }>{ label }</Label>
          </LabelContainer>
        }
        <IconWrapper lookAndFeel = { lookAndFeel }>
          { rightSideIcon !== undefined && rightSideIcon }
        </IconWrapper>
      </ButtonWithIconContainer>
    </Ripple>
  );
};
